if (!customElements.get('popup-advise')) {
  class PopupAdvise extends ModalDialog {
    constructor() {
      super();

      this.storageKey = `popup-advise-${this.dataset.sectionId}-${this.dataset.dismissKey || 'default'}`;

      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });

      if (this.shouldShow()) {
        const delay = Number(this.dataset.delay || 0) * 1000;
        this.openTimer = setTimeout(() => this.show(), delay);
      }
    }

    shouldShow() {
      if (this.dataset.designMode === 'true') return true;
      if (this.dataset.homeOnly === 'true' && this.dataset.isHome !== 'true') return false;

      const frequency = this.dataset.frequency || 'once';
      if (frequency === 'always') return true;

      try {
        if (frequency === 'session') {
          return sessionStorage.getItem(this.storageKey) !== 'dismissed';
        }
        return localStorage.getItem(this.storageKey) !== 'dismissed';
      } catch (error) {
        return true;
      }
    }

    hide() {
      super.hide();
      this.rememberDismiss();
    }

    rememberDismiss() {
      if (this.dataset.designMode === 'true') return;

      const frequency = this.dataset.frequency || 'once';
      if (frequency === 'always') return;

      try {
        if (frequency === 'session') {
          sessionStorage.setItem(this.storageKey, 'dismissed');
        } else {
          localStorage.setItem(this.storageKey, 'dismissed');
        }
      } catch (error) {
        // Storage may be unavailable
      }
    }
  }

  customElements.define('popup-advise', PopupAdvise);
}
